---
de:
  errors:
    messages:
      carrierwave_download_error: konnte nicht heruntergeladen werden
      carrierwave_integrity_error: hat keinen erlaubten Dateityp
      carrierwave_processing_error: konnte nicht verarbeitet werden
      content_type_blacklist_error: Sie dürfen keine %{content_type}-Dateien hochladen
      content_type_whitelist_error: 'Sie dürfen keine %{content_type}-Dateien hochladen, erlaubte Typen: %{allowed_types}'
      extension_blacklist_error: 'Sie dürfen keine %{extension}-Dateien hochladen, verbotene Typen: %{prohibited_types}'
      extension_whitelist_error: 'Sie dürfen keine %{extension}-Dateien hochladen, erlaubte Typen: %{allowed_types}'
      max_size_error: Dateigröße muss kleiner sein als %{max_size}
      min_size_error: Dateigröße muss größer sein als %{min_size}
      mini_magick_processing_error: 'Bearbeitung mit MiniMagick fehlgeschlagen; möglicherweise ist es kein Bild? Ursprünglicher Fehler: %{e}'
      rmagick_processing_error: Bearbeitung mit rmagick fehlgeschlagen; möglicherweise ist es kein Bild?
